import React from "react";

import Guest from "../../../layouts/Guest";
import BudhabathCheckAdminForm from "views/Forms/Private/EventCheckForm/BudhabathCheckAdminForm";

function EventCheckInSearchPage() {

  return (
    <>
      <Guest>
        <BudhabathCheckAdminForm />
      </Guest>
    </>
  );
}

export default EventCheckInSearchPage;
